module.exports = __webpack_public_path__ + "img/other-icon-img7.bd0a2183.svg";